import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { AuthProvider } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import './styles/base.css';
import './styles/ui.css';
import './styles/settlements.css';
import './styles/admin.css';
import './styles/files.css';
import './styles/controls.css';
import './styles/board.css';
import './styles/alerts.css';
import './styles/myday.css';
import './styles/leadStages.css';
import './styles/leads.css';
import './styles/leadCards.css';
import './styles/leadImport.css';
import './styles/leadLog.css';
import './styles/documents.css';
import './styles/clientwork.css';
import './styles/money.css';
import './styles/calendar.css';
import './styles/calendarHeader.css';
import './styles/responsive.css';
// The design (tokens.css): html.ds is on every page, so these restyle every screen.
import './styles/tokens.css';
import './styles/ds.css';
import './styles/work.css';
import './styles/dsShell.css';
import './styles/moneyScreen.css';
import './styles/lists.css';
import './styles/listPrint.css';
// Motion last, so its reduced-motion switch overrides everything above it.
import './styles/dsMotion.css';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <ThemeProvider>
          <App />
        </ThemeProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);
